import React from 'react';
import { useCart } from '../context/CartContext';

export default function Toast() {
  const { toast } = useCart();
  if (!toast?.show) return null;
  return (
    <div style={{
      position: 'fixed', bottom: 24, left: '50%', transform: 'translateX(-50%)',
      background: '#1a3a2a', color: '#fff', padding: '12px 24px',
      borderRadius: 50, fontSize: 14, fontWeight: 600,
      boxShadow: '0 8px 32px rgba(0,0,0,0.25)', zIndex: 9999,
      whiteSpace: 'nowrap', maxWidth: '90vw', textAlign: 'center',
      animation: 'fadeInUp 0.2s ease'
    }}>
      {toast.msg}
    </div>
  );
}
